import { Children, type PropsWithChildren } from "react"

import { Trans } from "@/hooks/useTranslation"

import styles from "./TipList.module.scss"

export const TipList = (props: PropsWithChildren) => {
  const { children } = props

  return (
    <ul className={styles.tipsList}>
      {Children.map(children, (child, index) => {
        if (!child) return null

        return (
          <li key={index}>
            <Trans>{child}</Trans>
          </li>
        )
      })}
    </ul>
  )
}
